<template>
  <div class="ud-wrap">
    <div class="ud-card">
      <div class="ud-icon">
        <svg viewBox="0 0 120 120" width="120" height="120" aria-hidden="true">
          <circle cx="60" cy="60" r="54" fill="#eef3ff" />
          <g fill="none" stroke="#409eff" stroke-width="5" stroke-linecap="round">
            <circle cx="60" cy="60" r="30" stroke="#409eff" opacity="0.25" />
            <path d="M60 30 a30 30 0 0 1 26 15" stroke="#409eff" />
          </g>
          <g fill="#409eff">
            <rect x="56" y="22" width="8" height="14" rx="2" />
            <rect x="56" y="84" width="8" height="14" rx="2" />
            <rect x="22" y="56" width="14" height="8" rx="2" />
            <rect x="84" y="56" width="14" height="8" rx="2" />
            <rect x="33" y="33" width="8" height="12" rx="2" transform="rotate(45 37 39)" />
            <rect x="79" y="33" width="8" height="12" rx="2" transform="rotate(-45 83 39)" />
            <rect x="33" y="75" width="8" height="12" rx="2" transform="rotate(-45 37 81)" />
            <rect x="79" y="75" width="8" height="12" rx="2" transform="rotate(45 83 81)" />
          </g>
          <circle cx="60" cy="60" r="12" fill="#409eff" />
          <circle cx="60" cy="60" r="5" fill="#fff" />
        </svg>
      </div>
      <h1 class="ud-title">{{ $t("underDevelopment.title") }}</h1>
      <p class="ud-desc">{{ $t("underDevelopment.desc") }}</p>
      <div v-if="featurePath" class="ud-path">
        <span class="ud-path-label">{{ $t("underDevelopment.path") }}</span>
        <code>{{ featurePath }}</code>
      </div>
      <el-button type="primary" round @click="goHome">
        {{ $t("underDevelopment.back") }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnderDevelopment",
  computed: {
    featurePath() {
      return this.$route && this.$route.path ? this.$route.path : "";
    },
  },
  methods: {
    goHome() {
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
.ud-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  padding: 24px;
  box-sizing: border-box;
}

.ud-card {
  text-align: center;
  max-width: 480px;
  padding: 40px 32px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
}

.ud-icon {
  margin-bottom: 16px;
}

.ud-icon svg {
  animation: ud-spin 6s linear infinite;
}

@keyframes ud-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.ud-title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 600;
  color: #303133;
}

.ud-desc {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.6;
  color: #909399;
}

.ud-path {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  margin-bottom: 24px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
}

.ud-path code {
  font-family: Consolas, Monaco, monospace;
  color: #409eff;
  word-break: break-all;
}
</style>
